// extracted by mini-css-extract-plugin
export default {"wrapRenderStep":"AddImage_wrapRenderStep__1DuWk","step1":"AddImage_step1__-6rsC","wrapImage":"AddImage_wrapImage__mPn15"};